import React, { useMemo } from 'react';
import { useSelector } from 'react-redux'
import { MaterialReactTable } from 'material-react-table';
import { Feedback } from '../feedback';

const Result = () => {
    const result = useSelector((state) => state.asr.result)
    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
                size: 200,
            },
            {
                accessorKey: 'designation',
                header: 'Designation',
                size: 200,
            },
            {
                accessorKey: 'organization',
                header: 'Organization',
                size: 200,
            },
            {
                accessorKey: 'office',
                header: 'Office',
                size: 150,
            },
            {
                accessorKey: 'mobile',
                header: 'Mobile',
                size: 150,
            },
            {
                accessorKey: 'officePhone',
                header: 'Office Phone',
                size: 150,
            }
        ]
    );

    return (
        <div>
            <div className='result mini-card'>
                <h4>Result</h4>
                    <div style={{marginBottom: '5px'}}>
                        <MaterialReactTable columns={columns} data={result} />
                    </div>
                <div>
                <Feedback 
                    type = {"result"} />
                </div>
            </div>
            
        </div>
    );
};


export default Result;